import ActionTypes from "../actions/actionTypes";

const initialState = {
  types: [],
  categories: [],
  directory: [],
};

const businessDirectoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.BUSINESS_DIRECTORY_LOADED:
      state = action.payload;
      break;
    default:
      break;
  }
  return state;
};

export default businessDirectoryReducer;



// WEBPACK FOOTER //
// ./src/reducers/businessDirectoryReducer.js